var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward = function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_360_5312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62327 4.3682L8.19614 6.45969V7.80438C8.19614 7.86596 8.14516 7.91634 8.08284 7.91634H1.98406C1.92175 7.91634 1.87076 7.86596 1.87076 7.80438V6.45857L1.46742 4.32565C1.22157 4.31109 1.02783 4.10844 1.02783 3.86436C1.02783 3.6102 1.23743 3.40195 1.49575 3.40195C1.74274 3.40195 1.95007 3.59564 1.96253 3.84085L3.77642 4.19017L4.6862 2.85444C4.61142 2.77271 4.5661 2.6641 4.5661 2.54542C4.5661 2.29014 4.7757 2.08301 5.03402 2.08301C5.2912 2.08301 5.5008 2.29126 5.5008 2.54542C5.5008 2.66298 5.45662 2.76935 5.38297 2.85108L6.33807 4.24951L8.13609 3.86884C8.15535 3.62923 8.35929 3.44449 8.60174 3.44449C8.85893 3.44449 9.06966 3.65275 9.06966 3.9069C9.06966 4.15323 8.87139 4.357 8.62327 4.3682Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_360_5312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10
  })))));
};
export default SvgAward;